import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from "axios";
import ElementUI from 'element-ui';
import '../src/styles/theme.scss'

Vue.use(ElementUI);
import '../src/styles/font.css'
import { message } from './utils/resetMessage';
Vue.prototype.$message = message;

import "./utils/kiaBuriedPoint";


const instance = axios.create({});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 断网提示
    if (!navigator.onLine) {
      // Toast('网络异常，请检查网络');
    }
    console.log("%c config", "font-size:25px;color:green;", config);
    config.headers = {
      ...config.headers,
      // "X-Fontre-Auth-Model": "token",
      // "X-Fontre-Auth-Access": sessionStorage.getItem("kia_token") || "",
      "Access-Control-Allow-Origin" :"*"
    };
    return config;
  },
  (error) => {
    console.log("请求拦截error", error);
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = instance;
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
